module.exports = __webpack_public_path__ + "img/ico-check-white.e1ee9837.svg";